package devxertech.com.pages.portfolio

import CommonDivider
import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.Palette
import devxertech.com.theme.toSitePalette
import devxertech.com.section.DesktopNavigationAnchor
import com.varabyte.kobweb.compose.ui.attrsModifier
import kotlinx.browser.window
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px

@Composable
fun CommonPortfolioBox(image: String, title: String, path: String) {
    val breakpoint = rememberBreakpoint()
    val sitePalette = ColorMode.current.toSitePalette()
    DesktopNavigationAnchor(path, Modifier.margin(topBottom = 30.px)
            .cursor(Cursor.Pointer)
            .flexWrap(FlexWrap.Wrap)) {
        Row(
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        Column(
            modifier = Modifier.width(if (window.screen.width > 500) 427.px else 300.px)
                .height(if (window.screen.width > 500) 325.px else 288.px)
                .padding(topBottom = 20.px, leftRight = if (window.screen.width > 500) 30.px else 0.px)
                .borderRadius(11.px)
                .backgroundColor(sitePalette.bodyBackgroundSecondary.rgb)
                .boxShadow(
                    offsetY = 1.px,
                    blurRadius = 14.px,
                    color = Palette.CareerBoxShadow.rgbLight
                ),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Image(src = image,
                modifier = Modifier.attrsModifier { attr("alt", "$title project preview") }
                    .width(if (window.screen.width > 500) 360.px else 280.px)
                    .height(220.px).margin(top = 20.px))
            FieldTitleTextNormalSimple(
                title,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint <= Breakpoint.LG) 18.px else 20.px,
                marginTop = 10.px,
                fontWeight = 700,
                asH3 = true,
            )

            val tags = listOf("React Native", "Next JS", "Php", "Python")
            val tagColor = sitePalette.commonSecondaryButtonColor.rgb
            val tagGap = if (breakpoint <= Breakpoint.SM) 5.px else 14.px

            Row(
                modifier = Modifier
                    .flexWrap(FlexWrap.Wrap)
                    .gap(tagGap)
                    .margin(bottom = 10.px),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Center
            ) {
                tags.forEachIndexed { index, tag ->
                    FieldTitleTextNormalSimple(
                        text = tag,
                        color = tagColor,
                        fontSize = 14.px,
                    )
                    if (index < tags.size - 1) {
                        CommonDivider(height = 15, width = 1, color = tagColor)
                    }
                }
            }
        }
        }
    }
}
